export default {
  "Cut Audio": "音声データを切り取る",
  "HitPaw Online Audio Cutter": "HitPawオンライン音声データ切断機",
  "Trim or cut any audio files online.": "どのようなオンラインの音声ファイルも切り取ります。",
  "Cut": "切る",
  "Fade in": "フェードイン",
  "Fade out": "フェードアウト",
  "Cut from": "から切り抜く",
  "to": "まで",
  "Extract selection": "選択を抽出する",
  "Delete selection": "選択を削除する",
  "Adjust New": "新しいものに対応する",
  "Cut New": "新しいものを切り取る",
  "Adjust Volume": "音声を調節する",
  "HitPaw Online Volume Changer": "HitPawオンライン音量変換機",
  "Turn up or Turn down the volume of audio.": "音声データのボリュームを上げる又は下げる。",
  "Volume": "ボリューム",
  "Change Speed": "スピードを変える",
  "HitPaw Online Audio Speed Changer": "HitPawオンライン再生スピード変換機",
  "Speed up or slow down audios online easily.": "オンライン音声データの再生スピードを簡単に速める又は緩める。",
  "Speed": "スピード",
  "Format": "形式",
  "Size": "サイズ",
  "Duration": "期間",
};
